import React from "react";
import { ContactForm } from "./ContactForm";
import { StaticWorldMap } from "./StaticWorldMap";

/**
 * Contact Form Section Component
 * Tailwind Version mit dezentem Gradient (dunkle Farben beibehalten)
 */
export const ContactFormSection: React.FC = () => {
  return (
    <section
      id="kontakt"
      className="min-h-screen pt-[100px] pb-[100px] md:pt-[200px] md:pb-[200px] overflow-hidden"
      style={{
        contain: "layout style paint",
        willChange: "transform",
        transform: "translateZ(0)",
        backgroundColor: "#0d0d0d",
      }}
    >
      {/* Background Map - Static CSS/SVG version for performance */}
      <StaticWorldMap />

      {/* Overlay Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <div className="mb-12">
          <p
            className="font-bold text-sm uppercase tracking-[0.2em] text-[#b7ab98] select-none"
            style={{
              textShadow: "0 2px 4px rgba(0,0,0,0.5)",
            }}
          >
            Kontakt
          </p>
        </div>

        {/* Contact Form */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mt-12">
          <div className="w-full lg:max-w-xl">
            {/* Gradient Container - Dezenter Gradient mit dunklen Farben */}
            <div
              className="rounded-2xl p-8 border border-white/5"
              style={{
                background: 'linear-gradient(145deg, #1a1a1a 0%, #141414 50%, #0f0f0f 100%)',
                boxShadow: '8px 10px 20px -4px rgba(0, 0, 0, 0.5)',
              }}
            >
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
